<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-delete"
      scrollable
      centered
      button-size="sm"
    >
      <template #modal-title>
        <i class="fas fa-columns"></i> CRM -
        {{ boardSituation ? 'Desarquivar' : 'Arquivar' }} Quadro
      </template>
      <div class="form-group row pt-3 pb-3">
        <div class="col-md-12 text-center">
          <h5>
            Deseja realmente {{ boardSituation ? 'desarquivar' : 'arquivar' }} o
            quadro <strong>{{ boardName }}</strong
            >?
          </h5>
          <br />
          <button
            type="button"
            class="btn btn-default btn-sm"
            @click="hideModal"
            v-b-tooltip.hover
            :title="'Não'"
          >
            <i class="fas fa-times-circle"></i
            ><span class="d-md-down-none"> Não</span></button
          >&nbsp;
          <button
            type="button"
            class="btn btn-danger btn-sm"
            @click="onUpdate"
            v-b-tooltip.hover
            :title="'Sim'"
          >
            <i class="fas fa-minus-circle"></i
            ><span class="d-md-down-none"> Sim</span>
          </button>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">&nbsp;</div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'CRMFile',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  },
  computed: {
    boardName () {
      let result = ''
      if (this.data && this.data.nome) {
        result = this.data.nome
      }
      return result
    },
    boardSituation () {
      let result = false
      if (this.data && this.data.arquivado) {
        result = this.data.arquivado
      }
      return result
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-delete'].show()
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    onUpdate () {
      this.data.arquivado = !this.data.arquivado
      loading.push()
      BoardRepository.Board_Update(this.data.id, this.data)
        .then((response) => {
          loading.pop()
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          this.hideModal()
          this.$emit('Back')
        })
        .catch((error) => {
          loading.pop()

          let errorMessage = 'O quadro não pode ser arquivado pois a regra de Movimentação Automática de Card está ativa. Por favor, inative a regra antes de arquivar'

          if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
            errorMessage = error.response.data.errors[0].message
          } else if (error.message) {
            errorMessage = error.message
          }

          toast.warning(errorMessage)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/modal/crmfilemodal.vue